import { render, staticRenderFns } from "./AccountReport.vue?vue&type=template&id=04641d05&scoped=true&lang=pug"
import script from "./AccountReport.js?vue&type=script&lang=js&external"
export * from "./AccountReport.js?vue&type=script&lang=js&external"
import style0 from "./AccountReport.vue?vue&type=style&index=0&id=04641d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04641d05",
  null
  
)

export default component.exports